import React, { Component } from 'react';
import { connect } from "react-redux";
import {FreeConstants} from "../../components-basic/customRoute/Endpoints/Endpoint/FreeConstants";

const ClassicOutputNotice = ({ premium }) => {
	return (
		<React.Fragment>
		{ !premium ?
      <div className="notice notice-info inline" style={{opacity: 1, display: 'block'}}>
        <p>Through the basic version you are limited to output only {FreeConstants.outputFields}. Get Pro to output unlimited fields.</p>
      </div> : ''
    }
		</React.Fragment>
	)
};

export default connect( state => ({
	premium: state.premium
}))(ClassicOutputNotice);
